import LoadingStyled from "./LoadingStyled";
import { useTranslation } from "../../i18n/hooks/useTranslation";

const Loading = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <LoadingStyled>
      <span
        role="banner"
        aria-label={t("loading.pageLoading")}
        className="loader"
      ></span>
    </LoadingStyled>
  );
};

export default Loading;
